import React from "react";
import { TechnicainService, ProjectService } from "../../../services";
import { Link, withRouter } from "react-router-dom";
import {
  Button,
  Modal,
  Select,
  Row,
  Col,
  Input,
  message,
  Form,
  Table,
  Divider,
  Popconfirm,
  PageHeader,
  Space,
} from "antd";
import { Config } from "../../../config";
import "./style.scss";
import PaginationDetail from "../../PaginationDetail";
import queryString from "query-string";
import TechnicianAdd from "../technician-form";
import TechnicianEdit from "../technician-edit";
import { Moment } from "../../../helpers";
import TechnicianView from "../technician-view";
import FormItem from "antd/lib/form/FormItem";
import {
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
const { Column, ColumnGroup } = Table;
const IconText = ({ type, text }) => <span>{text}</span>;

const { Option } = Select;

class TechnicialIndex extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = React.createRef();
    this.state = {
      initLoading: true,
      loading: false,
      loadingProject: false,
      data: [],
      showFormAdd: false,
      showFormEdit: false,
      showFormAssign: false,
      showModalView: false,
      editId: "",
      searchParams: {
        project_id: "",
        status: "",
        q: "",
        f: "home_no",
        sortField: "",
        sortOrder: "",
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: Config.pager.limit,
        pageCount: 0,
      },
      item: {},
      visibleModalView: false,
      confirmLoading: false,
      projects: [{ id: 1, name: "noom" }],
      listJobStatus: [],
    };
  }

  formRef = React.createRef();

  setPageParams(params) {
    this.setState({
      pagination: {
        current: params.currentPage,
        total: params.totalCount,
        pageSize: params.perPage,
        pageCount: params.pageCount,
      },
    });
  }

  handleSearch = (values) => {
    this.setState({
      initLoading: true,
      loading: true,
    });
    const pager = this.state.pagination;
    const pageParams = { page: 1, "per-page": pager.pageSize };
    const params = { pageParams, ...values };
    console.log("params", pageParams);
    TechnicainService.search(pageParams)
      .then((rs) => {
        const data = rs.data["items"];
        const pager = rs.data["_meta"];
        this.setPageParams(pager);

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        });
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status;
          if (code === 404) {
            message.warning(err.response.statusText);
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        });
      });
  };

  handleTableChange = (pager, filters, sorter) => {
    this.setState({
      initLoading: true,
      loading: true,
    });
    this.state.pagination.current = pager.current;
    const search = {
      sortField: sorter.field,
      sortOrder: sorter.order,
      ...filters,
    };
    const searchParams = { ...this.state };
    searchParams.sortField = sorter.sortField;
    searchParams.sortOrder = sorter.sortOrder;
    this.setState({
      ...searchParams,
    });
    this.getData(search)
      .then((rs) => {
        const data = rs.data["items"];
        const pager = rs.data["_meta"];
        this.setPageParams(pager);

        this.setState({
          data: data,
          list: data,
          loading: false,
          initLoading: false,
        });
      })
      .catch((err) => {
        if (err.response) {
          const code = err.response.status;
          if (code === 404) {
            message.warning(err.response.statusText);
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
        });
      });
  };

  /**
   * แสดงข้อมูลตาม Filter ที่เลือกไว้
   */
  getData = (params) => {
    const paramsSearch = {
      page: this.state.pagination ? this.state.pagination.current : 1,
      "per-page": this.state.pagination
        ? this.state.pagination.pageSize
        : Config.pager.limit,
      project_id: this.state.searchParams.project_id,
      status: this.state.searchParams.status,
      f: this.state.searchParams.f,
      q: this.state.searchParams.q,
    };
    const allParams = { ...paramsSearch, ...params };
    return TechnicainService.search(allParams);
  };

  /**
   * รีโหลดข้อมูล โดยไม่ต้อง reset Filter
   */
  reloadData = () => {
    this.setState({
      initLoading: true,
      loading: true,
    });
    this.getData()
      .then((rs) => {
        const data = rs.data["items"];
        const pager = rs.data["_meta"];
        this.setPageParams(pager);

        this.setState({
          data: data,
          loading: false,
          initLoading: false,
        });
      })
      .catch((err) => {
        const pager = { ...this.state.pagination };
        pager.current = 1;
        pager.total = 0;

        if (err.response) {
          const code = err.response.status;
          if (code === 404) {
            message.warning(err.response.statusText);
          }
        }
        this.setState({
          data: [],
          loading: false,
          initLoading: false,
          pagination: pager,
        });
      });
  };

  /**
   * ข้อมูลสถานะใบแจ้งหนี้
   */
  getStatus() {
    TechnicainService.getStatus().then((rs) => {
      if (rs) {
        const data = rs.data["data"];
        this.setState({ listJobStatus: data });
      }
    });
  }
  /**
   * ข้อมูลโครงการทั้งหมด
   */
  getProjects() {
    this.setState({
      loadingProject: true,
    });
    ProjectService.all().then((pj) => {
      if (pj) {
        const dataProject = pj.data["data"];
        this.setState({ projects: dataProject });
        this.setState({
          loadingProject: false,
        });
        this.getData().then((rs) => {
          const data = rs.data["items"];
          const pager = rs.data["_meta"];
          this.setState({
            initLoading: false,
            data: data,
          });
          this.setPageParams(pager);
        });
      }
    });
  }

  componentDidMount() {
    const { form } = this.props;
    // const qry = queryString.parse(this.props.location.search)

    // ดึงรายชื่อโครงการทั้งหมดมาตอนเปิดหน้าครั้งแรก
    this.getProjects();

    // โหลดข้อมูลสถานะ
    this.getStatus();
    // โหลดข้อมูลใบแจ้งซ่อม

    this.handleSearch();
  }

  onChangeProject = (value) => {
    this.setState((prevState) => ({
      searchParams: {
        ...prevState.searchParams,
        project_id: value,
      },
    }));
    // this.setQueryString()
    setTimeout(() => {
      this.handleSearch();
    }, 1000);
  };
  onChangeWorkStatus = (value) => {
    this.setState((prevState) => ({
      searchParams: {
        ...prevState.searchParams,
        status: value,
      },
    }));
    // this.setQueryString()
  };
  onChangeSearchFeild = (value) => {
    this.setState((prevState) => ({
      searchParams: {
        ...prevState.searchParams,
        f: value,
      },
    }));
    // this.setQueryString()
  };
  onChangeQ = (e) => {
    e.persist();
    this.setState((prevState, props) => ({
      searchParams: {
        ...prevState.searchParams,
        q: e.target.value,
      },
    }));
    // this.setQueryString()
  };

  setStatus = (item, status) => {
    if (status.value != undefined) {
      TechnicainService.setStatus(item.id, {
        status: status.value,
      }).then((rs) => {
        const dataStatus = rs.data["data"];
        const { data } = this.state;
        const index = data.indexOf(item);
        data[index] = dataStatus;
        this.setState({
          data,
        });
      });
    }
  };

  resetForm() {
    this.formRef.current.resetFields();
    this.setState({
      data: [],
      searchParams: {
        project_id: "",
        status: "",
        q: "",
        f: "",
        sortFeild: "",
        sortOrder: "",
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: this.state.pagination.perPage,
        pageCount: 0,
      },
    });
    this.handleSearch();
  }

  //  cancelItem = (item) => {
  //   TechnicainService.cancel(item.id).then((rs) => {
  //     if (rs) {
  //       const data = rs.data['data']
  //       const { list } = this.state
  //       const index = list.indexOf(item)
  //       list[index] = data
  //       this.setState({
  //         list,
  //       })
  //       message.success(rs.data['message'])
  //     }
  //   })
  // }

  showFormAdd = () => {
    this.setState({ showFormAdd: true });
  };
  hideModalAdd = () => {
    this.setState({ showFormAdd: false });
  };
  /**
   * ดูรายละเอียดใบแจ้งซ่อม
   */
  showModalView = (item) => {
    this.setState({
      visibleModalView: true,
      item: {},
    });
    TechnicainService.view(item.id).then((item) => {
      this.setState({
        item: item.data["data"],
      });
    });
  };

  showModalEdit = (job) => {
    console.log("edit", this.state.showFormEdit);
    this.setState({
      editId: job.id,
      item: {},
    });

    TechnicainService.view(job.id).then((rs) => {
    
      this.setState({
        showFormEdit: true,
        item: rs.data.data
      });
      console.log("rs", rs.data.data);
      console.log("showFormEdit", this.state.showFormEdit);
    });
  };
  showModalView = (item) => {
    this.setState({
      editId: item.id,
      item: {},
    });
    TechnicainService.view(item.id).then((item) => {
      this.setState({
        showModalView: true,
        item: item.data["data"],
      });
    });
  };

  hideModalEdit = () => {
    this.setState({
      showFormEdit: false,
      editId: "",
    });
  };
  hideModalView = () => {
    this.setState({
      showModalView: false,
      editId: "",
    });
  };

  deleteRecord = (row) => {
    const index = this.state.data.indexOf(row);
    TechnicainService.delete(row.id).then((rs) => {
      this.state.data.splice(index, 1);
      message.success(rs.data["message"]);
      this.reloadData();
    });
  };

  render() {
    const {
      initLoading,
      loading,
      loadingProject,
      pagination,
      projects,
      listJobStatus,
      searchParams,
      photos,
      data,
    } = this.state;
    const qry = queryString.parse(this.props.location.search);
    const showStatus = (record) => {
      const status = record.active.toString();
      if (status == "1")
        return (
          <div
            style={{
              backgroundColor: "green",
              color: "#ffffff",
              padding: 3,
              textAlign: "center",
            }}
          >
            Active
          </div>
        );
      if (status == "0")
        return (
          <div
            style={{
              backgroundColor: "red",
              color: "#ffffff",
              padding: 3,
              textAlign: "center",
            }}
          >
            Inactive
          </div>
        );
    };

    return (
      <React.Fragment>
        <PageHeader title="ช่าง" style={{ backgroundColor: "#ffffff" }}>
          <Form id="technichian-list" ref={this.formRef}>
            <Row justify="space-between" gutter={{ xs: 3, sm: 3, md: 3 }}>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 6 }}
                lg={{ span: 5 }}
              >
                <Form.Item name="project_id">
                  <Select
                    loading={loadingProject}
                    key="dropdown-project"
                    // defaultValue={eval(qry.project_id ? qry.project_id : '')}
                    showSearch
                    allowClear
                    style={{ width: "100%" }}
                    placeholder="-เลือกโครงการ-"
                    optionFilterProp="children"
                    optionLabelProp="label"
                    onChange={this.onChangeProject}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {projects.map((p, index) => (
                      <Option
                        key={"project-" + p.id}
                        value={p.id}
                        label={p.name}
                      >
                        {p.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5 }}
                lg={{ span: 3 }}
              >
                <Form.Item name="job_status">
                  <Select
                    placeholder="-เลือกสถานะ-"
                    name="status"
                    style={{ width: "100%" }}
                    onChange={this.onChangeStatus}
                    allowClear
                    optionLabelProp="label"
                  >
                    {listJobStatus
                      ? listJobStatus.map((status, key) => (
                          <Option
                            key={key}
                            value={status.value}
                            label={status.text}
                          >
                            {status.text}
                          </Option>
                        ))
                      : null}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 4 }}
                lg={{ span: 4 }}
              >
                <Form.Item name="f">
                  <Select
                    placeholder="-ประเภทคำค้นหา-"
                    name="f"
                    style={{ width: "100%" }}
                    onChange={this.onChangeSearchFeild}
                    allowClear
                  >
                    <Option value="firstname">ชื่อ</Option>
                    <Option value="lastname">นามสกุล</Option>
                    <Option value="id">ID</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5 }}
                lg={{ span: 5 }}
              >
                <Form.Item name="q">
                  <Input
                    name="q"
                    placeholder="คำค้นหา.."
                    onChange={this.onChangeQ}
                    onPressEnter={this.onSearch}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 4 }}
                lg={{ span: 4 }}
              >
                <Button
                  type="primary"
                  loading={loading || initLoading}
                  disabled={loading || initLoading}
                  icon={<SearchOutlined />}
                  shape="circle"
                  onClick={this.handleSearch}
                  title="ค้นหา"
                />
                <Space />
                <Space />
                <Button
                  type="light"
                  htmlType="reset"
                  icon={<ReloadOutlined />}
                  shape="round"
                  className="submit"
                  onClick={() => this.resetForm()}
                  title="รีเซ็ตการค้นหา"
                ></Button>
                <Space />
                <Space />
                <Button
                  type="light"
                  shape="round"
                  icon={<PlusCircleOutlined />}
                  onClick={() => this.showFormAdd()}
                  title="เพิ่มใบแจ้งซ่อม"
                ></Button>
              </Col>
            </Row>
          </Form>

          {/* ///////////////////////////////////////// */}
          <PaginationDetail data={pagination} />

          <Table
            key="table-maintenance"
            size="small"
            bordered
            // scroll={{ y: 400 }}
            columns={this.state.columns}
            rowKey={(record) => record.id}
            dataSource={this.state.data}
            pagination={this.state.pagination}
            loading={this.state.loading}
            onChange={this.handleTableChange}
          >
            <Column title="ID" dataIndex="id" key="id" />
            <Column
              title="ประเภท"
              dataIndex="technicianTypeName"
              key="technicianTypeName"
            />
            <Column title="ชื่อ" dataIndex="firstname" key="firstname" />
            <Column title="นามสกุล" dataIndex="lastname" key="lastname" />
            <Column title="ชื่อเล่น" dataIndex="nickname" key="nickname" />
            <Column
              title="โครงการ"
              dataIndex="project.name"
              key="project_name"
            />

            <Column
              title="สถานะ"
              key="active"
              render={(text, record) => {
                return showStatus(record);
              }}
            />
            <Column
              title="สร้างเมื่อ"
              dataIndex="created_at"
              render={(created_at) =>
                created_at != "0000-00-00" && created_at != ""
                  ? Moment.unix(created_at).utc(7).format("lll")
                  : ""
              }
              key="created_at"
            />
            <Column
              title="Action"
              key="action"
              render={(text, record) => (
                <span>
                  <Button
                    icon={<SearchOutlined />}
                    size="small"
                    onClick={() => this.showModalView(record)}
                  ></Button>
                  <Divider type="vertical" />
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    onClick={() => this.showModalEdit(record)}
                  ></Button>
                  <Divider type="vertical" />
                  <Popconfirm
                    placement="leftTop"
                    title={"ยืนยันลบรายการนี้ ? ID#" + record.id}
                    onConfirm={() => this.deleteRecord(record)}
                  >
                    <Button
                      type="danger"
                      icon={<DeleteOutlined />}
                      size="small"
                    ></Button>
                  </Popconfirm>
                </span>
              )}
            />
          </Table>

          {/* ////////////// START Modal view /////////// */}
          <Modal
            open={this.state.showModalView}
            onCancel={this.hideModalView}
            footer=""
            centered
            bodyStyle={{ padding: "5" }}
            closable
          >
            {this.state.editId && this.state.showModalView ? (
              <TechnicianView
                itemId={this.state.editId}
                item={this.state.item}
                projects={this.state.projects}
                hideModal={this.hideModalView}
              />
            ) : null}
          </Modal>
          {/* ////////////// END Modal view /////////// */}

          {/* ////////////// start Modal ADD /////////// */}

          {this.state.showFormAdd ? (
            <TechnicianAdd
              hideModal={this.hideModalAdd}
              reload={() => this.reloadData()}
              visible={this.state.showFormAdd}
              onCancel={() => this.hideModalAdd()}
            />
          ) : (
            ""
          )}
          {/* ////////////// END Modal ADD /////////// */}

          {/* ////////////// START Modal Edit /////////// */}

          {this.state.showFormEdit === true ? (
            <TechnicianEdit
              visible={this.state.showFormEdit}
              editId={this.state.editId}
              item={this.state.item}
              projects={this.state.projects}
              hideModal={() => this.hideModalEdit()}
              reload={() => this.reloadData()}
              onCancel={() => this.hideModalEdit()}
            />
          ) : (
            ""
          )}

          {/* ////////////// END Modal Edit /////////// */}
        </PageHeader>
      </React.Fragment>
    );
  }
}
export default TechnicialIndex;
